<template>
  <div class="popup-expired">
    <!-- Support PC Tablet -->
    <b-modal
      v-if="windowWidth >= 600 && windowHeight >= 600"
      id="modal-expired"
      ref="my-modal-expired"
      centered
      class="modal-expired"    
      crm_at="modal_expired"
      hide-footer
    >
    <div :class="currentLocale">
      <div class="pb-2 pt-3 modal-expired-text-main" crm_at="detail_expired">
        {{ Title }}
      </div>
      <div class="pb-4 modal-expired-text-sub" crm_at="detail_expired">
        {{ Detail }}
      </div>
      <div class="timer mb-2">
        <img class="icon-timer" src="@/assets/images/timer.svg" alt=""/>
        <span class="lbl-expired"> {{ lbl.dashboard.expired }}</span>
      </div>
      <div class="list-expired">
        <a-list :data-source="dataExpired">
          <a-list-item
            slot="renderItem"
            slot-scope="item"
            class="wrapper-expired-list"
            crm_at="wrapper_expired_list"
          >
            <a-list-item-meta>
              <div slot="title">
                <div class="title-point">
                  {{ item.point }} {{ lbl.main.points }}
                </div>
                <div class="date-point">
                  {{ lbl.dashboard.will_be_expired }} {{ item.date }}
                </div>
              </div>
            </a-list-item-meta>
          </a-list-item>
        </a-list>
      </div>
    </div>
    </b-modal>

    <!-- Support Mobile -->
    <b-modal
      v-else
      id="modal-expired"
      ref="my-modal-expired"
      centered
      class="modal-expired"
      crm_at="modal_expired"
      hide-footer
    >
    <div :class="currentLocale">
      <div class="pb-2 pt-3 modal-expired-text-main" crm_at="detail_expired">
        {{ Title }}
      </div>
      <div class="pb-4 modal-expired-text-sub" crm_at="detail_expired">
        {{ Detail }}
      </div>
      <div class="timer mb-2">
        <img class="icon-timer" src="@/assets/images/timer.svg" alt=""/>
        <span class="lbl-expired"> {{ lbl.dashboard.expired }}</span>
      </div>
      <div class="list-expired">
        <a-list :data-source="dataExpired">
          <a-list-item
            slot="renderItem"
            slot-scope="item"
            class="wrapper-expired-list"
            crm_at="wrapper_expired_list"
          >
            <a-list-item-meta>
              <div slot="title">
                <div class="title-point">
                  {{ item.point }} {{ lbl.main.points }}
                </div>
                <div class="date-point">
                  {{ lbl.dashboard.will_be_expired }} {{ item.date }}
                </div>
              </div>
            </a-list-item-meta>
          </a-list-item>
        </a-list>
      </div>
    </div>
    </b-modal>
  </div>
</template>

<script>
import CommonMixin from '@/mixin/CommonMixin'
import ResponsiveMixin from '@/mixin/ResponsiveMixin'
import Locale from '@/helper/Locale.js'

export default {
  components: {},
  mixins: [CommonMixin, ResponsiveMixin],
  props: {
    show: Boolean,
    data: Object,
  },
  data() {
    return {
      Title: '',
      Detail: '',
      backgroundColor: '',
      currentLocale: Locale.getLocale(),
      textColor: '',
      Condition: '',
      dataExpired: []
    }
  },
  watch: {
    show: function (newVal, oldVal) {
      console.log('Prop changed: ', newVal, ' | was: ', oldVal)
      if (newVal == true) {
        this.genInfo()
      }
    },
  },
  mounted() {
    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      if (modalId == 'modal-expired') {
        this.$refs['my-modal-expired'].hide()
        this.$emit('changeExpired', false)
      }
    })
  },
  methods: {
    genInfo() {
      this.$refs['my-modal-expired'].show()
      this.Title = this.data.title
      this.Detail = this.data.detail
      this.backgroundColor = '#033a70'
      this.textColor = '#033a70'
      this.dataExpired = this.data.expired
    },
    gotoMyReward() {
      console.log('gotoMyReward')
      window.location.href = '/myrewards'
    },
    close() {
      this.$refs['my-modal-expired'].hide()
      this.$emit('changeExpired', false)
    },
  },
}
</script>

<style lang="scss">
@import '@/style/_mixin.scss';
#modal-expired {
  .modal-header {
    background-color: #ffffff;
    border-bottom: unset;
  }
  .modal-body {
    padding: 0 3rem 3rem;
  }
  .modal-content {
    border-radius: 8px;
  }
  @mixin btn() {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    border-radius: 100px;
    font-size: 18px;
    height: 50px;
  }
  .btn-alert-expired {
    @include btn();
    width: 80%;
  }
  .modal-expired-text-main {
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: 0.5px;
    text-align: left;
    color: #212121;
  }
  .modal-expired-text-sub {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.57;
    letter-spacing: 0.15px;
    text-align: left;
    color: #616161;
  }
  .icon-expired {
    width: 100%;
  }

  .icon-timer {
    margin-top: -5px;
  }

  .lbl-expired {
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: 0.1px;
    text-align: left;
    color: #424242;
  }

  .more_point {
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #033a70;
  }

  .title-point {
    font-size: 16px;
    font-weight: 600;
    line-height: 1.5;
    letter-spacing: 0.5px;
    text-align: left;
    color: #ff5252;
  }

  .date-point {
    font-size: 14px;
    font-weight: normal;
    line-height: 1.5;
    letter-spacing: 0.5px;
    text-align: left;
    color: #ff5252;
    text-transform: initial;
  }

  .ant-list-split .ant-list-item {
    border-bottom: initial;
    border-radius: 4px;
    background-color: rgba(255, 82, 82, 0.2);
    padding: 10px 15px;
    margin-bottom: 8px;
  }

  .modal-header .close {
    padding: 1rem 1rem;
    margin: -1rem -1rem -1rem auto;
    font-size: 34px;
    font-weight: 100;
  }
}
</style>